import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames'
import { withLocalize, Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router";
import { isOnPath } from '../../store/apiWrapper';
import { searchType, searchActions, defaultPaging } from "../../store/searchStore";
import { apiGet, getHostApi } from '../../store/apiWrapper';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { entityIdentRowActions } from '../../store/entityIdentRowStore';

import QuickSearchResults from '../search/quickSearchResults';
import { lastSubjectActions } from '../../store/lastSubjectsStore';
import moment from 'moment';
import { validateInput } from '../../store/storeFunctions';
class MenuSearchIcon extends React.Component {
    searchInputRef = undefined;
    opKetCodes = {
        9: function () { return false; }, /*TAB*/
        13: function () { return false; },
        16: function () { return false; }, /*SHIFT*/
        17: function () { return false; }, /*CTRL*/
        18: function () { return false; }, /*ALT*/
        27: function () { return false; }, /*ESC*/
        32: function () { return false; }, /*SPACE*/
        37: function () { return false; }, /*?*/
        38: function () { return false; }, /*?*/
        39: function () { return false; }, /*?*/
        40: function () { return true; }/*?*/
    }
    initialState = {
        search: "",
        query: null,
        isSearching: false,
        stamp: 0,
        validLength: false,
        subjectsLoading: false,
        subjectsError: null,
        qsResult: null
    };
    state = { ...this.initialState };

    UNSAFE_componentWillMount() {
        !this.props.ls.isLoading && !this.props.ls.dataLoaded && !this.props.ls.error && this.props.getSubjects();
        this.unlisten = this.props.history.listen((location, action) => {
            this.setState(this.initialState);
        });
    }
    componentWillUnmount() {
        this.unlisten();
    }

    render() {
        return (
            <div className='navbar-search-row navbar-search-row-multi-width mobile-hidden' style={{ flex: '1', flexDirection: 'column', justifyContent: 'center' }}>
                <div className='control'>
                    <div className={classnames('navbar-input-row', { 'is-square': localStorage.locales_menu_active_style === 'square' })} style={{ borderRight: "none" }}>

                        <input onFocus={() => this.onFocus()} ref={(el) => this.searchInputRef = el} onKeyUp={this.onInputChanged} onKeyDown={this.onSearchSubmit}
                            placeholder={this.props.translate("Search.Placeholder")} type="text" value={this.state.search}
                            onChange={(e) => this.setState({ search: e.target.value })} onInput={(e) => validateInput(e)}/>
                        <button className={classnames('bb-button search-small',
                            {
                                'empty': !this.state.query || this.state.query.length === 0,
                                'filled': this.state.query && this.state.query.length > 0,
                                'is-square': localStorage.locales_button_style === 'square'
                            })}
                            onClick={this.onSearchSubmit} style={{ display: 'flex', flex: 'none' }}>
                            <Translate id="Search.Common.Search" />
                        </button>
                    </div>
                    {this.props.search.quickSearchResults.navMenuDesktop && <div style={{ display: 'block', left: 0, minWidth: '100%', position: 'absolute', top: 'calc(100% + 1px)' }}>
                        <QuickSearchResults subId='navMenuDesktop'
                            condensed={true} condenseOnlyDoB={true}
                            mode={{ buttons: 'desktop|mobile', extraData: 'desktop', basicLink: 'none' }}
                            searchInputRef={[this.searchInputRef]} lsFilterType={undefined}
                            sr={this.state.qsResult} ls={!this.props.user.authentication.limitedUser ? this.props.ls.lastSearchedSubjects : []}
                            query={this.state.query} subjectsLoading={this.props.ls.isLoading} />
                    </div>}
                </div>
                { (this.state.isSearching || (this.props.ls.isLoading && this.props.search.quickSearchResults.navMenuDesktop)) && <div className='search-progress searching' style={{ marginLeft: '0.75em', maxWidth: 'calc(100% - 1.5em)' }} />}
            </div>
        );
    }

    onFocus = () => {
        !this.props.search.quickSearchResults.navMenuDesktop && this.props.showQuickSearchResults('navMenuDesktop');
    }

    onSearchSubmit = event => {
        if (isNullOrUndefined(event) || (event.type === 'keydown' && event.key !== 'Enter')) {
            return;
        }

        const term = this.state.search.trim();
        if (term !== null && term !== undefined && term.length > 2) {
            const dob = (term || '').replace(/\s/g, '').replace(/[/\\]/g, '');
            const isDob = moment(dob, 'DD.MM.YYYY', true).isValid() || moment(dob, 'D.M.YYYY', true).isValid();
            const isId = !isDob && dob.length >= 9 && dob.length <= 10 && dob.split('').filter(x => x >= '0' && x <= '9').length === dob.length && ['0', '1', '5', '6'].includes(dob.charAt(2));

            if (isOnPath({ prefix: "/search/results" })) {
                this.props.topMenuExpanded && this.props.expandTopMenu();
                let params = { country: 3, actualOnly: true };
                if (isDob || isId) {
                    params.isPo = false;
                    params.dob = term;
                } else {
                    params.name = term;
                }
                //makes the query
                this.props.getSubjects(searchType.BS, params, { ...defaultPaging });
            }
            //insert into history so there is track of what has been searched
            clearTimeout(this.state.pendingReq);
            if (isDob || isId) {
                this.props.history.push(`/search/results?type=${encodeURIComponent(searchType.BS)}&isPo=false&dob=${encodeURIComponent(term)}`);
            } else {
                this.props.history.push(`/search/results?type=${encodeURIComponent(searchType.BS)}&q=${encodeURIComponent(term)}`);
            }
            this.props.hideQuickSearchResults('navMenuDesktop');
            this.setState({ validLength: false, query: '', search: '' });
        }
    }

    onInputChanged = (event) => {
        if (isNullOrUndefined(event) || isNullOrUndefined(event.target) || isNullOrUndefined(event.target.value)) {
            this.props.hideQuickSearchResults('navMenuDesktop');
            this.setState({ query: '' });
            return;
        }

        const keyCode = event.keyCode.toString();
        if (Object.keys(this.opKetCodes).indexOf(keyCode) !== -1) {
            if (!this.opKetCodes[keyCode]())
                if (keyCode !== "32")
                    return;
                else if ((event.target || {}).selectionEnd === ((event.target || {}).value || {}).length)   //skip space only in the end
                    return;
        }

        const term = event.target.value.trim();
        if (event.target.value !== null && event.target.value !== undefined && term.length <= 2) {
            this.props.hideQuickSearchResults('navMenuDesktop');
            this.setState({ qsResult: null, query: term });
        }
        else if (event.target.value !== null && event.target.value !== undefined && term.length >= 3) {
            const dob = (term || '').replace(/\s/g, '').replace(/[/\\]/g, '');
            const isDob = moment(dob, 'DD.MM.YYYY', true).isValid() || moment(dob, 'D.M.YYYY', true).isValid();
            const isId = !isDob && dob.length >= 9 && dob.length <= 10 && dob.split('').filter(x => x >= '0' && x <= '9').length === dob.length && ['0', '1', '5', '6'].includes(dob.charAt(2));

            const newStamp = this.state.stamp + 1;
            this.props.showQuickSearchResults('navMenuDesktop');
            this.setState({ validLength: true, query: term, stamp: newStamp });
            this.loadQs((isDob || isId) ? '' : term, (isDob || isId) ? dob : '', newStamp);
        } else {
            this.setState({ validLength: false, query: term });
        }
    }

    loadQs = (query, dob, stamp) => {
        this.setState({ isSearching: true });
        if (this.state.pendingReq !== undefined) {
            clearTimeout(this.state.pendingReq);
        }
        this.setState({
            pendingReq: setTimeout(function () {
                apiGet.call(this, `${getHostApi()}/api/search/quick`, { query, stamp, dob },
                    res => {
                        if (res.data.stamp === this.state.stamp) {
                            this.setState({ qsResult: res.data });
                            this.props.syncFromSearch(res.data.subjects);
                        }
                    },
                    err => { },
                    alw => this.setState({ isSearching: false }))
            }.bind(this), 125)
        });
    }
}

export default withRouter(withLocalize(connect(
    state => ({ search: state.search, ls: state.lastSubjects, user: state.userContext }),
    dispatch => bindActionCreators(Object.assign({}, searchActions, lastSubjectActions, entityIdentRowActions), dispatch),
)(MenuSearchIcon)));